import { List, Map } from 'immutable';
import { connect, featureOn, SessionItem, SessionItemResult, QuizSession, QuizSessionResult, getResultInfo } from '@instructure/quiz-core';
import { Results as ResultsPresenter } from './presenter';
export function mapStateToProps(state, ownProps) {
  var quizSessionId = ownProps.quizSessionId;
  var quizSession = new QuizSession(state.getIn(['quizSessions', quizSessionId]));
  var qsrId = quizSession.authoritativeResult;
  var authoritativeResult = new QuizSessionResult(state.getIn(['quizSessionResults', qsrId]));
  var showItems = ownProps.showItems != false;
  var sessionItemResults = List(),
    sessionItems = List();
  if (showItems) {
    var scope = function scope(record) {
      return record.get('quizSessionId') === quizSessionId;
    };
    sessionItemResults = state.get('sessionItemResults', Map()).filter(scope).map(function (sir) {
      return SessionItemResult.create(sir);
    }).sortBy(function (sir) {
      return sir.position;
    }).toList();
    sessionItems = state.get('sessionItems', Map()).filter(scope).map(function (si) {
      return SessionItem.create(si);
    }).sortBy(function (si) {
      return si.position;
    }).toList();
  }

  // assume it has questions until loaded
  var hasQuestions = quizSession.isLoaded() ? quizSession.sessionItemsCount > 0 : true;
  // If the quiz has no questions, it will always be loading, so short-circuit it
  var needToLoad = hasQuestions && (!quizSession.isLoaded() || !authoritativeResult.isLoaded() || showItems && sessionItems.size === 0 || showItems && sessionItemResults.size === 0);
  return {
    appContainer: state.getIn(['ui', 'appContainer']),
    authoritativeResult: authoritativeResult,
    needToLoad: needToLoad,
    quizSession: quizSession,
    resultsFeedbackFFEnabled: featureOn('results_feedback'),
    sessionItemResults: sessionItemResults,
    sessionItems: sessionItems,
    showItems: showItems,
    isAutograding: quizSession.isLoaded() ? quizSession.autoGrading() : quizSession.inProgress()
  };
}
var mapDispatchToProps = {
  getResultInfo: getResultInfo
};
export var Results = connect(mapStateToProps, mapDispatchToProps)(ResultsPresenter);
export default Results;